import Navbar from './Navbar'
import React, { useEffect, useState } from 'react'
import FL1 from './bookIMG/frontline/FL1.jpg'
import white from './bookIMG/whitehouse/white_house.jpeg'
import we from './bookIMG/westend/we2.jpg'
import delisa from './bookIMG/delisa/delisa.jpg'
import frontline from './bookIMG/frontline/frontline.jpg'
import amen from './bookIMG/Amen/am1.jpg'
import ana from './bookIMG/Anarosa/An1.jpg'
import cana from './bookIMG/Canam/c1.jpeg'
import adom from './bookIMG/Adom bi/AB1.jpg'
import ban from './bookIMG/Banivallas/bn1.jpg'
import frank from './bookIMG/franko/fr2.jpg'
import gl from './bookIMG/Glory to god/gb1.jpeg'
import flint from './bookIMG/flint/flin1.jpg'
import morning from './bookIMG/morning star/ms1.jpg'
import man from './bookIMG/manchaster/ma1.png'
import sha from './bookIMG/shallom/sh1.jpeg'
import je from './bookIMG/jecado/jc1.jpg'
import happy from './bookIMG/happy_family/hf1.jpg'
import fplaza from './bookIMG/f-plaza/f1.jpg'
import fosua from './bookIMG/fosua home/f2.jpg'
import wag from './bookIMG/wagingo/wagingo.jpg'
import hal from './bookIMG/Hallowed/h1.jpg'
import no from './bookIMG/no weapon/nw1.jpg'
import p3 from './bookIMG/p3/p2.jpg'
import nyame from './bookIMG/nyameMeraku/nm4.jpg'
import st from './bookIMG/St Therisa/st1.jpg'
import './Home.css'
import { Link, useNavigate } from 'react-router-dom'
import Aos from 'aos'
import 'aos/dist/aos.css'
import { userContext } from '../App'
import { useContext } from 'react'
import Lottie from 'lottie-react'
import cat from './cat.json'
const Hostel = () => {
  useEffect(()=>{
    Aos.init({duration:2000})
  },[])
  const [offcampus,setoffcampus]=useState([{
    name:'FRONTLINE',
    Price:'Ghc 3000 - Ghc 5500',
    type:'Hostel',
    location:'Ayeduasi',  
    image:FL1
  },
  {
    name:'WEST-END',
    Price:'Ghc 2800 - Ghc 5000',
    type:'Hostel',
    location:'Ayeduasi', 
    image:we
  },
  {
    name:'Delisa',
    Price:'Ghc 3000 - Ghc 6000',
    type:'Hostel',
    location:'Kotei', 
    image:delisa
  },
  {
    name:'White house',
    Price:'Ghc 3000 - Ghc 6000',
    type:'Hostel',
    location:'Ayeduasi', 
    image:white
  },
  {
    name:'Amen',
    Price:'Ghc 3000 - Ghc 6000',
    type:'Hostel',
    location:'Ayeduasi', 
    image:amen
  },
  {
    name:'Nyame Mireku ',
    Price:'Ghc 3000 - Ghc 6000',
    type:'Hostel',
    location:'Ayeduasi', 
    image:nyame
  },
  {
    name:'Anarosa',
    Price:'Ghc 3200 - Ghc 5400',
    type:'Hostel',
    location:'Ayeduasi', 
    image:ana
  },
  {
    name:'Canam',
    Price:'Ghc 3000 - Ghc 6000',
    type:'Hostel',
    location:'Ayeduasi,Kotei', 
    image:cana
  },
  {
    name:'No weapon',
    Price:'Ghc 3000 - Ghc 5500',
    type:'Hostel',
    location:'Ayeduasi', 
    image:no
  },
  {
    name:'Adom Bi',
    Price:'Ghc 3000 - Ghc 6000',
    type:'Hostel',
    location:'Ayeduasi', 
    image:adom
  },
  {
    name:'Banivallas',
    Price:'Ghc 2300 - Ghc 4500',
    type:'Hostel',
    location:'Gaza', 
    image:ban
  },
  {
    name:'Franko',
    Price:'Ghc 3000 - Ghc 6000',
    type:'Hostel',
    location:'Ayeduasi', 
    image:frank
  },
  {
    name:'manchaster',
    Price:'Ghc 3000 - Ghc 5400',
    type:'Hostel',
    location:'Kotei', 
    image:man
  },
  {
    name:'Glory be to God',
    Price:'Ghc 2300 - Ghc 4000',
    type:'Hostel',
    location:'Kotei', 
    image:gl
  },
  {
    name:'Flint',
    Price:'Ghc 3100 - Ghc 6000',
    type:'Hostel',
    location:'Ayeduasi', 
    image:flint
  },
  {
    name:'morning star',
    Price:'Ghc 2800 - Ghc 6000',
    type:'Hostel',
    location:'kotei', 
    image:morning
  },
  {
    name:'Shalom',
    Price:'Ghc 2300 - Ghc 55000',
    type:'Hostel',
    location:'Ayeduasi', 
    image:sha
  },
  {
    name:'Jecado',
    Price:'Ghc 3000 - Ghc 5000',
    type:'Hostel',
    location:'Ayeduasi', 
    image:je
  },
  {
    name:'happy family',
    Price:'Ghc 3300 - Ghc 6000',
    type:'Hostel',
    location:'Ayeduasi', 
    image:happy
  },
  {
    name:'F Plaza',
    Price:'Ghc 3300 - Ghc 6300',
    type:'Hostel',
    location:'Ayeduasi,Kotei', 
    image:fplaza
  },
  {
    name:'Fosua home',
    Price:'Ghc 2400 - Ghc 5000',
    type:'Hostel',
    location:'Kotei', 
    image:fosua
  },
  {
    name:'Wagingo',
    Price:'Ghc 3400 - Ghc 6200',
    type:'Hostel',
    location:'Ayeduasi', 
    image:wag
  },
  {
    name:'Hallowed',
    Price:'Ghc 2400 - Ghc 4800',
    type:'Hostel',
    location:'Kotei', 
    image:hal
  },
  {
    name:'St theresa',
    Price:'Ghc 8000 - Ghc 17000',
    type:'Hostel',
    location:'Ayeduasi', 
    image:st
  },
  {
    name:'P3',
    Price:'Ghc 3000 - Ghc 6000',
    type:'Hostel',
    location:'Ayeduasi', 
    image:p3
  },
  ])
  const nav=useNavigate();
  const [search,hand,setsearch,location,setlocation,Locate,Kotei,Ayeduasi,Newsite,TechJunction,KNUSTCampus,Bomsu,Kumasi,price,setprice,main,price1,price2,price3,price4,price5,price6,price7,type,settype,types,Apartments,GuestHouse,homstel,Hostels,collapse,toggle,settoggle,toggler,arrow,setarrow, down,click,setclick,onpress]=useContext(userContext)
  return (
    <div>
      <Navbar />
      <div className='grid lg:grid-cols-4 md:mt-3 md:mx-3 mx-5 sm:justify-center rounded-md gap-6 md:grid-cols-3 mt-[100px]' style={{paddingTop:'10%'}}  >
    {offcampus.filter(item=>{
     const name=item.name.toLocaleLowerCase();
     const find=search.toLocaleLowerCase();
     return name.startsWith(find)
    }

    ).filter((post)=>{
      const look=location.toLocaleLowerCase();
      const loc=post.location.toLocaleLowerCase(); 
      if(look=='location'){
        return post
      }
      if(loc.includes(look)){
        return post
      }

  }).length > 0? offcampus.filter((post)=>{
    const name=post.name.toLocaleLowerCase();
    const find=search.toLocaleLowerCase(); 
    
    if(find==''){
      return post
    }
    if(name.startsWith(find)){
      return post
    }
  })
  .filter((post)=>{
      const look=location.toLocaleLowerCase();
      const loc=post.location.toLocaleLowerCase(); 
      if(look=='location'){
        return post
      }
      if(loc.includes(look)){
        return post
      }

  }).filter((post)=>{
    const cat=post.type.toLocaleLowerCase();
    const glory=type.toLocaleLowerCase();
    if(glory=='type'){
      return post
    }
    if(cat.includes(glory)){
      return post
    }
  }

  ).filter((post)=>{
    const pro=post.Price
    const pr=price;
    if(pr=='price'){
      return post
    }
    if(pro.includes(pro)){
      return post
    }
  }
    
  ).map(post=><div data-aos='fade-right'>
      <img className='rounded-lg shadow-md hover:-translate-y-5 cursor-pointer' style={{width:'400px', height:'300px'}} src= {post.image} onClick={()=>{
        {if(post.image===FL1){
          nav('frontline');
        }
        if(post.image===we){
          nav('westend');
        }
        if(post.image===delisa){
          nav('delisa');
        }
        if(post.image==amen){
          nav('amen')
        }
        if(post.image==frontline){
          nav('fapartment')
        }
        if(post.image==st){
          nav('therisa')
        }
        if(post.image==white){
          nav('whitehouse')
        }
        if(post.image==nyame){
          nav('nyame')
        }
        if(post.image==ana){
          nav('anarosa')
        }
        if(post.image==cana){
          nav('canam')
        }
        if(post.image==no){
          nav('noweapon')
        }
        if(post.image==adom){
          nav('adom')
        }
        if(post.image==ban){
          nav('banivallas')
        }
        if(post.image==frank){
          nav('franko')
        }
        if(post.image==man){
          nav('manchester')
        }
        if(post.image==gl){
          nav('glory')
        }
        if(post.image==flint){
          nav('flint')
        }
        if(post.image==morning){
          nav('morning')
        }
        if(post.image==sha){
          nav('shallom')
        }
        if(post.image==je){
          nav('jecado')
        }
        if(post.image==happy){
          nav('happy')
        }
        if(post.image==fplaza){
          nav('fplaza')
        }
        if(post.image==fosua){
          nav('fosua')
        }
        if(post.image==wag){
          nav('wagingo')
        }
        if(post.image==hal){
          nav('hallowed')
        }
        if(post.image==p3){
          nav('p3')
        }
      }
      }} />
      <h2 className='font-bold from-neutral-950 font-serif uppercase' >{post.name} </h2>
      <div className='  text-gray-700 '>{post.type}</div>
      <div className=' text-red-700 '>{post.Price}</div>
      <div className=' text-gray-700 font-bold text-md'>{post.location}</div>
    </div>):<div className=' bg-gray-200 md:w-[1620px] md:-mx-8 md:-mt-[60px] -mt-[60px] w-[412px] -mx-5'>
    <div className=' md:w-[400px] md:ml-[500px] '>
      <Lottie animationData={cat}/>
      </div>
      <h3 className=' md:text-3xl text-2xl font-bold font-serif md:ml-[440px] md:-mt-[47px] ml-4 -mt-14'>Sorry we couldn't find your search. </h3>
      </div>}
      </div>
    </div>
  )
}

export default Hostel